import React from 'react';
import PropTypes from 'prop-types';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Header, { headerItemsLabels } from '../../../Common/Header/header';
import { PL_DialogWrapper } from 'infrastructure/js/components/Dialog/dialog';
import ImportFilesJsonDialog from '../../../Dialogs/ImportFilesJsonDialog/importFilesJsonDialog';
import MaterialTypesViewGrid from './MaterialTypesViewGrid/materialTypesViewGrid';
import { MatSettingsMenuItemsIds } from '../../../../enums/navigationMenuItemsIds';
import { gridsNames } from '../../../../enums/gridsNames';
import {ImportAcceptFileTypes, ImportTypes} from '../../../../enums/importTypes';
import { Route, Switch } from 'react-router-dom';
import MaterialTypeFormWrapper from './materialTypeFormWrapper';
import PermissionManager from 'infrastructure/js/utils/permissionManager';
import {enumTypes, getEnumValue} from '../../../../utils/enumHelper';

export default class MaterialTypesView extends React.PureComponent {

  constructor(props) {
    super(props);

    this.labels = createLabelHelper('mat.administration.matsettings.materialtypes.view.');
  }

  componentDidMount() {
    // this.props.actions.init(false);
    this.props.actions.matSettingsPageActions.onSelectedMenuItemChanged(MatSettingsMenuItemsIds.NAV_ELEMENT_MATERIAL_TYPES);
  }

  getHeaderItems() {
    let { actions } = this.props;
    let hasRows = this.props.sHasRows;
    let selectedRowsData = this.props.sSelectedRowsData;

    return {
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
        },
        {
          id: "create",
          label: headerItemsLabels.CREATE,
          icon: "pl pl-icon-add",
          action: () => {
            this.props.history.push(`${this.props.match.url}/materialTypeForm`)
          },
        },
        {
          id: "edit",
          label: headerItemsLabels.EDIT,
          icon: "pl pl-edit-icon",
          disabled: !(hasRows && selectedRowsData.size === 1),
          action: () => {
            this.props.history.push(`${this.props.match.url}/materialTypeForm/${selectedRowsData.get(0)?.id}/edit`)
          },
          actionData: selectedRowsData.get(0)
        }
      ],

      kebab: {
        menuItems: [
          {
            id: "importMaterialTypes",
            label: headerItemsLabels.IMPORT_MATERIAL_TYPES,
            action: actions.header.importItems,
            disabled: false,
            actionData: {
              importTypes: [ImportTypes.IMPORT_MATERIAL_TYPES],
              acceptFileTypes: [ImportAcceptFileTypes.CSV],
              parentComponent: actions.reload
            }
          },
          ...( PermissionManager.isCoCEnabled() ? [
            {
              id: 'importQPlForMaterialTypeJson',
              label: headerItemsLabels.IMPORT_MATERIAL_TYPES_JSON,
              action: actions.header.onImportFilesJsonClick,
              actionData: {
                importType: ImportTypes.IMPORT_QPL_FOR_MATERIAL_TYPES_JSON,
                acceptFileTypes: [ImportAcceptFileTypes.JSON],
                parentComponent: actions.reload
              }
            }] : []),
          {
            id: "exportMaterialTypes",
            label: headerItemsLabels.EXPORT_MATERIAL_TYPES,
            action: actions.header.exportItems,
            disabled: !hasRows,
            actionData: { gridName: gridsNames.ADMINISTRATION_MAT_SETTINGS_MATERIAL_TYPES }
          },
          ...( PermissionManager.isCoCEnabled() ? [
            {
              id: 'updateQPLsForMaterialType',
              label: headerItemsLabels.UPDATE_QPLS_FROM_CUSTOMER,
              action: actions.updateQPLsForMaterialType,
              actionData: {
                entitiesType: getEnumValue(enumTypes.OBJECT_TYPE)('MATERIAL_TYPE'),
              }
            }] : []),
          ...( PermissionManager.isQplEnabled() ? [
            {
              id: 'exportMaterialTypesJson',
              label: headerItemsLabels.EXPORT_MATERIAL_TYPES_JSON,
              action: actions.exportMaterialQplRules,
              disabled: !(hasRows && selectedRowsData.size === 1),
              actionData:  selectedRowsData?.get(0)?.id,
            }] : []),
          {
            id: "remove",
            label: headerItemsLabels.DELETE,
            action: actions.header.onRemoveMaterialTypesClick,
            disabled: (!selectedRowsData || selectedRowsData.size === 0),
            actionData: selectedRowsData
          }
        ]
      }
    };
  }

  reloadPage = () => {
    this.props.actions.init(true);
  };

  render() {
    let title = this.labels.get("title");
    let headerItems = this.getHeaderItems();
    return (

      // <div className="material-types-page">
        <Switch>
          <Route key='materialTypeFormKey' exact
                 path={`${this.props.match.path}/materialTypeForm/:materialTypeId?/:mode?`}
                 component={MaterialTypeFormWrapper}
          >
          </Route>
          <Route key='materialTypesViewKey' path={this.props.match.path}>
            <div className="administration-view">
              <div className="title">{title}</div>

              <Header {...headerItems}/>

              <MaterialTypesViewGrid
                actions={{...this.props.actions.materialTypesViewGridActions, ...this.props.actions.fetchEntitiesActions}}
              />

              <PL_DialogWrapper
                dialogComponent={ImportFilesJsonDialog}
                show={this.props.sImportFilesJsonDialogData.get("show")}
                actions={this.props.actions.importFilesJsonDialogActions}
                sData={this.props.sImportFilesJsonDialogData}
                reloadParentComponent={this.reloadPage}
                // sLoggedInUser={this.props.sLoggedInUser}
              />
            </div>
          </Route>

        </Switch>
      // </div>
        );
  }
}

MaterialTypesView.propTypes = {
  sGrid: PropTypes.object
};

